import ResponsiveAppBar from "../../components/navbar/Navbar";
import React, { useState } from "react";
import "./Archive.css";
import data from "./TemplteData.json";
import { useEffect } from "react";
import { useLocation } from "react-router";
import { Button } from "@mui/material";

function ArchiveMain() {
  const [searchTerm, setSearchTerm] = useState("");
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [ResponsiveAppBar]);
  return (
    <div className="archive-container">
      <h1 className="archive-title">The company's archive</h1>
      <h2 className="archive-sub-title">looking for data?</h2>
      <div className="template-container">
        <div className="search-input-container">
          <input
            className="search-input"
            type="text"
            placeholder="Search in archive..."
            onChange={(event) => {
              setSearchTerm(event.target.value);
            }}
          />
        </div>
        <div className="data-container">
          {
            data 
              .filter((val) => {
                if(searchTerm == ""){
                  return val;
                }else if(val.title.toLowerCase().includes(searchTerm.toLowerCase())){
                  return val;
                }
              })
              .map((val) => {
                return(
                  <div className="cards-div">
                    <div className="template" key={val.id}>
                      <div className="img-div">
                        <img className="image" src={val.image} alt="" />
                        </div>
                        <h3 className="card-title">{val.title}</h3>
                        <p className="desctiption">{val.description}</p>
                        <div>
                          <Button className="file-btn">open files</Button>
                        </div>
                    </div> 
                  </div>
              );
            })}
        </div>
      </div>
      <div className="archive-fotter">
          <h1
            style={{ lineHeight: 1.25, fontSize: "65px", paddingTop: "10vh" }}
            className="footer-top"
          >
            success is not final. failur is not fatal.
            <br />
            it is the courage to continue that counts.
          </h1>
          <h3 className="footer-buttom">winston churchill</h3>
      </div>
    </div>
  );
}

export default ArchiveMain;
